module.exports = __webpack_public_path__ + "static/media/feelingProud.3f8d6a35.svg";